import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";
import { remove } from "lodash";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { DialogLinkQuizzesComponent } from "../../../@components/dialog-link-quizzes/dialog-link-quizzes.component";
import { DialogQuizContentComponent } from "../../../@components/dialog-quiz-content/dialog-quiz-content.component";
import { DialogTestQuizComponent } from "../../../@components/dialog-test-quiz/dialog-test-quiz.component";
import { DialogYesNoPromptComponent } from "../../../@components/dialog-yesno-prompt/dialog-yesno-prompt.component";

import Exercise, { ExerciseQuiz } from "../../../models/exercise.model";
import Quiz from "../../../models/quiz.model";

@Component({
  selector: "ngx-exercise-quizzes",
  styleUrls: ["./quizzes.component.scss"],
  templateUrl: "./quizzes.component.html",
})
export class EditExerciseQuizzesComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() exercise: Exercise = new Exercise();
  @Output() onUpdateQuizzes: EventEmitter<any> = new EventEmitter();

  submitted = false;
  loading = false;

  constructor(
    private toastrService: NbToastrService,
    private router: Router,
    private dialogService: NbDialogService
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  createExQuiz() {
    this.dialogService
      .open(DialogQuizContentComponent, {
        context: {
          title: "Soạn nội dung cho câu hỏi",
          quizId: "",
          isEditSource: false,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value: Quiz) => {
        if (value && value.id) {
          this.onCreateExQuiz(value);
        }
      });
  }

  editExQuiz(item: ExerciseQuiz) {
    this.dialogService
      .open(DialogQuizContentComponent, {
        context: {
          title: "Cập nhật nội dung cho câu hỏi",
          quizId: item.quizId,
          isEditSource: true,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value: Quiz) => {
        if (value && value.id) {
          item.quizTitle = value.title;
          this.exercise.noQuizValue = 0;
          this.onUpdateQuizzes.emit(this.exercise);
        }
      });
  }

  deleteExQuiz(item) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa câu hỏi này?",
          description: "Câu hỏi sẽ bị xóa trong bài tập này!",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          remove(this.exercise.exQuizzes, (e) => {
            return e.quizId == item.quizId;
          });
          this.exercise.noQuiz--;
          this.exercise.noQuizValue = -1;
          this.onUpdateQuizzes.emit(this.exercise);
        }
      });
  }

  testExQuiz(item) {
    this.dialogService.open(DialogTestQuizComponent, {
      context: {
        quizId: item.quizId,
      },
      closeOnBackdropClick: false,
    });
  }

  //Open dialog Quiz Content
  onLinkQuiz() {
    this.dialogService
      .open(DialogLinkQuizzesComponent, {
        context: {
          header: "Xin vui lòng chọn câu hỏi.",
          exQuizzes: this.exercise.exQuizzes ? this.exercise.exQuizzes : [],
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value: Quiz) => {
        if (value && value.id) {
          this.onCreateExQuiz(value);
        }
      });
  }

  // control event
  private onCreateExQuiz(value: Quiz) {
    const newExQuiz = new ExerciseQuiz();
    newExQuiz.exerciseId = this.exercise.id;
    newExQuiz.quizId = value.id;
    newExQuiz.quizTitle = value.title;

    if (!this.exercise.exQuizzes) {
      this.exercise.exQuizzes = [];
    }

    this.exercise.exQuizzes.push(newExQuiz);
    this.exercise.noQuiz++;
    this.exercise.noQuizValue = 1;
    this.onUpdateQuizzes.emit(this.exercise);
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
